import { NgModule } from '@angular/core';
import Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import highchartsTheme from './highcharts-theme';

@NgModule({
  imports: [HighchartsChartModule],
  exports: [HighchartsChartModule]
})
export class HighchartsInsightModule {
  constructor() {
    Highcharts.setOptions(highchartsTheme);
  }
}
